import { appstr } from "./appstr";

export function GetBlankVal() {
  return "<" + appstr("Blank") + ">";
}
